import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";
import { ADDRESS, EMAIL, ADMIN_EMAIL, PHONE, PHONE_LINK } from "@/lib/site";
import { CATEGORIES } from "@/data/content";

const NAV = [
  { label: "Home", href: "#top" },
  { label: "Occasions", href: "#collections" },
  { label: "Shop", href: "#products" },
  { label: "Corporate", href: "#corporate" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="bg-noir text-ivory border-t border-gold/20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-ivory/60" data-testid="footer-tagline">
            Handcrafted gifts, hampers and artisan crafts for every occasion —
            personalized down to the ribbon and delivered across India.
          </p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-gold-light" data-testid="footer-domain">
            atozgiftandcrafthouse.com
          </p>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold-light">Explore</p>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={(e) => {
                    e.preventDefault();
                    if (l.href === "#top") window.scrollTo({ top: 0, behavior: "smooth" });
                    else scrollToId(l.href);
                  }}
                  className="text-sm text-ivory/70 hover:text-gold-light transition-colors duration-300"
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold-light">Gifts</p>
          <ul className="mt-4 space-y-2.5">
            {CATEGORIES.map((c) => (
              <li key={c}>
                <a
                  href="#products"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToId("#products");
                    window.dispatchEvent(new CustomEvent("set-product-filter", { detail: c }));
                  }}
                  className="text-sm text-ivory/70 hover:text-gold-light transition-colors duration-300"
                  data-testid={`footer-category-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold-light">Reach us</p>
          <ul className="mt-4 space-y-2.5 text-sm text-ivory/70">
            <li data-testid="footer-phone">
              <a href={PHONE_LINK} className="hover:text-gold-light transition-colors duration-300">{PHONE}</a>
            </li>
            <li data-testid="footer-email">
              <a href={`mailto:${EMAIL}`} className="hover:text-gold-light transition-colors duration-300 break-all">{EMAIL}</a>
            </li>
            <li data-testid="footer-admin-email">
              <a href={`mailto:${ADMIN_EMAIL}`} className="hover:text-gold-light transition-colors duration-300 break-all">{ADMIN_EMAIL}</a>
            </li>
            <li data-testid="footer-address">{ADDRESS}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-ivory/45" data-testid="footer-copyright">
            © {new Date().getFullYear()} A to Z Gift and Craft House · All rights reserved
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/45" data-testid="footer-made-with">
            Made with love in India
          </p>
        </div>
      </div>
    </footer>
  );
}
